export enum AuthPath {
  email_confirmation = 'email-confirmation',
  identification_redirect = 'identification_redirect',
  loggin = 'loggin',
  password = 'password',
  recover = 'recover',
  reset = 'reset',
  url = 'url',
}

export enum AuthQueryParam {
  token = 'token',
  code = 'code',
  email = 'email',
  fundId = 'fundId',
  leadId = 'leadId',
}
